export default class Dropdown {

    constructor() {
        this.addEvents();
    }

    addEvents() {
        const dropdownTogglers = document.querySelectorAll('.nx-dropdown-wrapper .nx-dropdown-toggler');
        if(dropdownTogglers) {

            dropdownTogglers.forEach((toggler) => {
                toggler.addEventListener('click', function (e) {
                    const parentDropdownWrapper = this.closest('.nx-dropdown-wrapper');
                    if (parentDropdownWrapper) {
                        const isActive = parentDropdownWrapper.classList.contains('active');

                        dropdownTogglers.forEach((e) => {
                            e.closest('.nx-dropdown-wrapper').classList.remove("active");
                        });

                        if (!isActive) {
                            parentDropdownWrapper.classList.add('active');
                        }
                    }
                });
            });

            window.addEventListener('click', (e) => {
                if(!(e.target.matches('.nx-dropdown-wrapper') || e.target.matches('.nx-dropdown-wrapper *'))){
                    const dropdownWrappers = document.querySelectorAll('.nx-dropdown-wrapper');
                    if(dropdownWrappers) {
                        dropdownWrappers.forEach((wrapper) => {
                            wrapper.classList.remove('active');
                        });
                    }
                }
            });
        }

    }
}
